import React from 'react';
import { connect } from 'react-redux';
import Provisions from './Provisions';
import Toggle from './Toggle';

const ProvisionList = ({
  companies,
  selectedNumbers,
  filterEmails,
  companySearchFilter,
  gateways,
  onOrder,
  onToggleChange,
  sameForAll,
  provider
}) => {

  return (
    <div className="table-header-fixed provision-table" style={{ height: '500px' }}>
        <div className="forAllToggle">
        <h6 style={{ marginRight: '10px', marginBottom: '0px' }}>Same for all: </h6>
        <Toggle value={sameForAll} onToggle={onToggleChange} />
      </div>
      <table className="provisionList">
      <thead>
            <tr>
              <th>Number</th>
              <th>SMS/MMS</th>
              <th>Route</th>
              <th>Company</th>
              <th>User/Edge Device</th>
              <th style={{ width: '100px' }}>Temp DID</th>
              <th>Action</th>
            </tr>
          </thead>
        <tbody>
        {selectedNumbers?.map((number, index) => (
            <Provisions
              orderedNumbers={[]}
              key={index}
              telephoneNumber={number.telephoneNumber}
              index={index}
              isDisabled={sameForAll}
              companies={companies?.docs}
              gateways={gateways}
              filterEmails={filterEmails}
              companySearchFilter={companySearchFilter}
              onOrder={onOrder}
              provider={provider}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
  companies: state.AppState.companies, 
  numbers: state.AppState.numbers, 
  gateways: state.AppState.provisioning.gateways, 
});

export default connect(mapStateToProps)(ProvisionList);
